import { baseKeymap } from 'prosemirror-commands'
import { dropCursor } from 'prosemirror-dropcursor'
import { gapCursor } from 'prosemirror-gapcursor'
import { history } from 'prosemirror-history'
import { keymap } from 'prosemirror-keymap'
import { Schema } from 'prosemirror-model'
import { QueryClient } from 'react-query'
import { buildKeymap } from '../Keymap'
import { ProseInputProps } from '../Types'
import { buildInputRules } from '../inputRules'
import { EmojiPlugin } from './EmojiPlugin/EmojiPlugin'
import { MentionsPlugin } from './MentionsPlugin/MentionsPlugin'
import { PastePlugin } from './PastePlugin'

export const buildPlugins = (schema: Schema, queryClient: QueryClient, overrides?: ProseInputProps['plugins']) => [
  buildInputRules(schema),
  EmojiPlugin(),
  overrides?.mentions ? overrides.mentions : MentionsPlugin({ queryClient }),
  keymap(buildKeymap(schema)),
  keymap(baseKeymap),
  dropCursor(),
  gapCursor(),
  history(),
  PastePlugin(queryClient),
  ...(overrides?.other || []),
]
